import { useState, useEffect } from "react"

const DEFAULT_ELEMENTS = [
  {
    id: "text1",
    type: "text",
    x: 50,
    y: 50,
    text: "Hello, World!",
    fontSize: 20,
    fill: "black",
    rotation: 0,
  },
]

/**
 * Hook to manage canvas elements with localStorage persistence, scoped per user
 * @param {string} userId - Current user's UID to isolate stored canvas data
 * @returns {Object} { elements, setElements, clearElements }
 */
export function useLocalStorage(userId) {
  const storageKey = userId ? `canvasElements_${userId}` : null

  const [elements, setElements] = useState(() => {
    if (!storageKey) return DEFAULT_ELEMENTS
    const saved = localStorage.getItem(storageKey)
    return saved ? JSON.parse(saved) : DEFAULT_ELEMENTS
  })

  useEffect(() => {
    if (!storageKey) return
    localStorage.setItem(storageKey, JSON.stringify(elements))
  }, [elements, storageKey])

  const clearElements = () => {
    setElements([])
    if (storageKey) {
      localStorage.removeItem(storageKey)
    }
  }

  return {
    elements,
    setElements,
    clearElements,
  }
}
